function get_info () {
    return this.request('user/get_info')
}


export default {
    get_info
}
